<video
  #videoPlayer
  class="course-video"
  [class.video-visible]="!hideVideo"
  [controls]="!requireFullscreen || isVideoPlaying"
></video>